module.exports = __webpack_public_path__ + "static/2-1c6e7993761c7a330669cc87f8c04c0f.jpg";